
import {Tokenstorage} from "./library/tokenstorage";
import {NotarisdossierApi} from "./library/notarisdossierApi";
import {Clusterconfig} from "./library/clusterconfig";
import {MailParser} from "./library/mailParser";
import {PlatformApi} from "./library/platformApi";


/**
 * Some global variables for the state of the add-in when the taskpane is loaded
 */
class AppState {
  static version = 'Build 55';
  static debugMode = false;
  static configLoaded = false;
  static messageFilenameFormat = null;
  static maxUploadSize = 10485760;
  static outlookMessageCapability = null;
  static graphMailboxes = [];
  static messageRefreshInProgress = false;
  static messageRefreshVersion = 0;
  static platformSsoDialog = null;
  static platformSsoState = null;
  static authenticationWarning = null;
}


/**
 * This is the Office.onReady method which is executed after the addin has finished loading. Make sure that we don't
 * execute code outside this method.
 */
Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {

    // Update layout
    uiUpdate();

    // Init select2
    initSelectFile();

    // Add handlers
    $('#btn-select-cluster').on('click', btnSelectClusterClick);
    $('#btn-reset-cluster').on('click', btnLogoutClick);
    $('#btn-logout').on('click', btnLogoutClick);
    $('#btn-save-email').on('click', btnSaveMailClick);
    $('#switch-check-attachments').on('change', btnCheckAttachments)
    $('#btn-toggle-debug').on('click', btnToggleDebugClick);
    $('#btn-refresh-token').on('click', btnRefreshTokensClick);
    $('#btn-platform-sso').on('click', btnPlatformSsoClick);
    $('#form-login').on('submit', formLoginSubmit);
    $('#div-log').on('click', clearLog);
    $('#cb-save-eml-message').on('change', uiUpdateSaveMailButton);
    $('#div-office').hide();

    // Update layout when a new message is selected
    Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, function () {
      logMessage('Mailbox.ItemChanged event');
      uiUpdate();
    });
  }
});


/**
 * Toggle attachments checked
 */
function btnCheckAttachments() {
  logMessage('TaskPane.btnCheckAttachments()');
  let switchAttachmentsChecked = $('#switch-check-attachments:checked').length > 0;
  $('.cb-attachment').prop('checked', switchAttachmentsChecked);
}


/**
 * Toggle debug mode
 */
function btnToggleDebugClick() {
  AppState.debugMode = !AppState.debugMode;
  clearLog();
  let diagnostics = Office.context.diagnostics;
  logMessage('Diagnostics: ' + diagnostics.platform + ' '  + diagnostics.host + ' ' + diagnostics.version);
  logMessage('Version: ' + AppState.version);
  uiUpdate();
}


/**
 * General Exception handler, easy way to deal with errors.
 * Use this like: .catch((error) {generalExceptionHandler(error);});
 *
 * @param error with optional status and message
 */
function generalExceptionHandler(error)
{
  if (error === null || error === undefined) {
    uiShowError('Onbekende fout');
    return;
  }
  if (typeof error !== 'object') {
    uiShowError(error);
    return;
  }
  if (error.reauthenticationRequired) {
    requireReauthentication(error.message);
    return;
  }
  if (error.status !== undefined && error.status == 401) {
    error.message = 'Fout bij opnieuw inloggen';
    btnLogoutClick();
  }
  if (error.message !== undefined) {
    uiShowError(error.message);
  } else {
    uiShowError(error);
  }
}


/**
 * button for refreshtokens with automated error handling.
 */
function btnRefreshTokensClick()
{
  NotarisdossierApi.refreshTokens()
    .catch((error) => {
      if (error !== null && error !== undefined && error.reauthenticationRequired) {
        generalExceptionHandler(error);
        return;
      }
      error = {
        status: error.status,
        message: 'Fout bij opnieuw inloggen'
      };
      generalExceptionHandler(error);
    });
}


/**
 * Log a message (also to console). Outlook does not support the console (except the web version) and we need to be
 * able to trace problems.
 *
 * @param msg
 */
export function logMessage(msg) {
  console.log(msg);

  let currentLog = $('#div-log').html();
  let messages = currentLog.split('<br>');
  if (currentLog === '') {
    messages = [];
  }
  messages.push(msg);
  if (messages.length > 20) {
    messages.shift();
  }
  $('#div-log').html(messages.join('<br>'));
}


/**
 * Minimal Mailbox API version we address to use
 * @returns {boolean}
 */
export function isMailboxAPISupported() {
  return Office.context.requirements.isSetSupported('Mailbox', '1.8');
}


/**
 * Clear the log
 */
function clearLog() {
  $('#div-log').html('');
}

/**
 * Get AppState Version
 * @returns {string}
 */
export function getAppStateVersion() {
  return AppState.version;
}

/**
 * Get diagnostics
 * @returns {string}
 */
export function getDiagnostics() {
  let diagnostics = Office.context.diagnostics;
  return 'Supported: ' + isMailboxAPISupported() + ', ' + diagnostics.platform + ' ' +
      diagnostics.host + ' ' + diagnostics.version;
}


function normalizeMailboxAddress(mailbox)
{
  if (mailbox === null || mailbox === undefined) {
    return '';
  }
  return mailbox.toString().trim().toLowerCase();
}


function getCapabilityMailboxes(capability)
{
  if (capability === null || capability === undefined) {
    return [];
  }
  if (Array.isArray(capability.mailboxes)) {
    return capability.mailboxes;
  }
  if (capability.mailbox !== undefined && capability.mailbox !== null) {
    return [capability.mailbox];
  }
  return [];
}


function getMailboxAddressFromCapabilityEntry(mailbox)
{
  if (mailbox === null || mailbox === undefined) {
    return null;
  }
  if (typeof mailbox === 'string') {
    return mailbox;
  }

  const keys = [
    'email',
    'email_address',
    'mailbox',
    'mailbox_address',
    'address',
    'userPrincipalName',
    'user_principal_name',
    'upn',
    'smtpAddress',
    'smtp_address',
  ];
  for (let i = 0; i < keys.length; i++) {
    if (mailbox[keys[i]] !== undefined && mailbox[keys[i]] !== null && mailbox[keys[i]] !== '') {
      return mailbox[keys[i]];
    }
  }
  return null;
}


function getBooleanCapability(capability, keys)
{
  if (capability === null || capability === undefined) {
    return null;
  }
  for (let i = 0; i < keys.length; i++) {
    if (capability[keys[i]] !== undefined) {
      const value = capability[keys[i]];
      if (typeof value === 'string') {
        return ['true', '1', 'yes', 'ja'].indexOf(value.trim().toLowerCase()) !== -1;
      }
      return value === true || value === 1;
    }
  }
  return null;
}


function mailboxEntryHasGraph(mailbox)
{
  if (mailbox === null || mailbox === undefined) {
    return false;
  }
  if (typeof mailbox === 'string') {
    return true;
  }

  const graphCapability = getBooleanCapability(mailbox, [
    'graph_message_save_available',
    'has_graph',
    'graph_available',
    'graph_enabled',
    'authorized',
    'is_authorized',
    'can_save_outlook_message',
  ]);
  if (graphCapability !== null) {
    return graphCapability;
  }

  if (mailbox.save_method !== undefined) {
    return mailbox.save_method === 'graph';
  }

  return false;
}


function capabilityAllowsLegacy(capability)
{
  const legacyCapability = getBooleanCapability(capability, [
    'legacy_message_save_allowed',
    'legacy_allowed',
    'legacyAllowed',
    'allow_legacy',
    'allowLegacy',
    'legacy_js_eml_allowed',
  ]);
  if (legacyCapability !== null) {
    return legacyCapability;
  }
  return false;
}


function createOutlookMessageCapabilityUnavailableError()
{
  return {
    message: 'Outlook Graph configuratie kon niet worden gecontroleerd. Meld opnieuw aan of probeer opnieuw.',
  };
}


function requireOutlookMessageCapability()
{
  if (AppState.outlookMessageCapability === null || AppState.outlookMessageCapability === undefined) {
    throw createOutlookMessageCapabilityUnavailableError();
  }
  return AppState.outlookMessageCapability;
}


function getCapabilityLegacyReason(capability, fallbackCapability = null, fallbackReason = 'no_authorized_graph_account')
{
  if (capability !== null && capability !== undefined && capability.legacy_reason !== undefined && capability.legacy_reason !== null && capability.legacy_reason !== '') {
    return capability.legacy_reason;
  }
  if (fallbackCapability !== null && fallbackCapability !== undefined && fallbackCapability.legacy_reason !== undefined && fallbackCapability.legacy_reason !== null && fallbackCapability.legacy_reason !== '') {
    return fallbackCapability.legacy_reason;
  }
  return fallbackReason;
}


function addMailboxCandidate(candidates, mailbox, source)
{
  const mailboxAddress = getMailboxAddressFromCapabilityEntry(mailbox);
  const normalizedMailbox = normalizeMailboxAddress(mailboxAddress);
  if (normalizedMailbox === '') {
    return;
  }
  if (candidates.findIndex((candidate) => candidate.normalizedMailbox === normalizedMailbox) !== -1) {
    return;
  }
  candidates.push({
    mailbox: mailboxAddress,
    normalizedMailbox: normalizedMailbox,
    source: source,
  });
}


function getOfficeUserMailbox()
{
  try {
    if (Office.context.mailbox.userProfile.emailAddress !== undefined) {
      return Office.context.mailbox.userProfile.emailAddress;
    }
  } catch (e) {
    logMessage('Could not read Office user mailbox: ' + e.message);
  }
  return null;
}


function getSharedMailboxOwner(mailItem)
{
  return new Promise((resolve) => {
    try {
      if (mailItem !== null && mailItem !== undefined && typeof mailItem.getSharedPropertiesAsync === 'function') {
        mailItem.getSharedPropertiesAsync(function(result) {
          if (result.status === Office.AsyncResultStatus.Succeeded && result.value !== null && result.value !== undefined) {
            if (result.value.owner !== undefined && result.value.owner !== null) {
              resolve(result.value.owner);
              return;
            }
            if (result.value.targetMailbox !== undefined && result.value.targetMailbox !== null) {
              resolve(result.value.targetMailbox);
              return;
            }
          }
          resolve(null);
        });
        return;
      }
    } catch (e) {
      logMessage('Could not read shared mailbox owner: ' + e.message);
    }
    resolve(null);
  });
}


function findCapabilityMailbox(mailbox, capability)
{
  const normalizedMailbox = normalizeMailboxAddress(mailbox);
  if (normalizedMailbox === '') {
    return null;
  }

  const mailboxes = getCapabilityMailboxes(capability);
  for (let i = 0; i < mailboxes.length; i++) {
    const capabilityMailbox = getMailboxAddressFromCapabilityEntry(mailboxes[i]);
    if (normalizeMailboxAddress(capabilityMailbox) === normalizedMailbox) {
      return mailboxes[i];
    }
  }
  return null;
}


function resolveMailboxFromCandidates(candidates, capability)
{
  const mailboxes = getCapabilityMailboxes(capability);
  for (let i = 0; i < candidates.length; i++) {
    const capabilityMailbox = findCapabilityMailbox(candidates[i].mailbox, capability);
    if (capabilityMailbox !== null) {
      const selectedMailbox = getMailboxAddressFromCapabilityEntry(capabilityMailbox) || candidates[i].mailbox;
      const hasGraph = mailboxEntryHasGraph(capabilityMailbox);
      return {
        selectedMailbox: selectedMailbox,
        detectedMailbox: candidates[i].mailbox,
        source: candidates[i].source,
        hasGraph: hasGraph,
        legacyReason: hasGraph ? null : getCapabilityLegacyReason(capabilityMailbox, capability, 'graph_not_enabled_for_mailbox'),
        matchedCapabilityMailbox: capabilityMailbox,
      };
    }
  }

  if (mailboxes.length === 1 && candidates.length === 0) {
    const onlyMailbox = mailboxes[0];
    const selectedMailbox = getMailboxAddressFromCapabilityEntry(onlyMailbox);
    const hasGraph = mailboxEntryHasGraph(onlyMailbox);
    return {
      selectedMailbox: selectedMailbox,
      detectedMailbox: selectedMailbox,
      source: 'single-capability-mailbox',
      hasGraph: hasGraph,
      legacyReason: hasGraph ? null : getCapabilityLegacyReason(onlyMailbox, capability, 'graph_not_enabled_for_mailbox'),
      matchedCapabilityMailbox: onlyMailbox,
    };
  }

  const detectedMailbox = candidates.length > 0 ? candidates[0].mailbox : null;
  return {
    selectedMailbox: null,
    detectedMailbox: detectedMailbox,
    source: 'unmatched',
    hasGraph: false,
    legacyReason: mailboxes.length > 0 ? 'no_matching_graph_mailbox' : getCapabilityLegacyReason(capability),
    matchedCapabilityMailbox: null,
  };
}


async function resolveCurrentMailbox(mailItem, capability)
{
  let candidates = [];
  const userMailbox = getOfficeUserMailbox();
  const sharedMailboxOwner = await getSharedMailboxOwner(mailItem);
  const hasAuthoritativeSharedMailbox = normalizeMailboxAddress(sharedMailboxOwner) !== '' &&
    normalizeMailboxAddress(sharedMailboxOwner) !== normalizeMailboxAddress(userMailbox);

  if (hasAuthoritativeSharedMailbox) {
    addMailboxCandidate(candidates, sharedMailboxOwner, 'shared-mailbox-owner');
  } else {
    addMailboxCandidate(candidates, userMailbox, 'user-profile');
  }

  const resolution = resolveMailboxFromCandidates(candidates, capability);
  resolution.hasAuthoritativeSharedMailbox = hasAuthoritativeSharedMailbox;
  logMessage(
    'Mailbox resolution: selected=' + resolution.selectedMailbox +
    ', detected=' + resolution.detectedMailbox +
    ', source=' + resolution.source +
    ', graph=' + resolution.hasGraph +
    ', legacy_reason=' + resolution.legacyReason
  );
  return resolution;
}


async function resolveCurrentMailboxCapability(mailItem)
{
  const capability = requireOutlookMessageCapability();
  let resolution = await resolveCurrentMailbox(mailItem, capability);

  if (!resolution.hasGraph && resolution.detectedMailbox !== null && resolution.legacyReason === 'no_matching_graph_mailbox') {
    try {
      logMessage('Mailbox resolution: retry capability for mailbox ' + resolution.detectedMailbox);
      const mailboxCapability = await NotarisdossierApi.getOutlookMessageCapability(resolution.detectedMailbox);
      const mailboxResolution = await resolveCurrentMailbox(mailItem, mailboxCapability);
      return {
        capability: mailboxCapability,
        resolution: mailboxResolution,
      };
    } catch (e) {
      logMessage('Mailbox resolution: mailbox-specific capability failed');
      throw createOutlookMessageCapabilityUnavailableError();
    }
  }

  return {
    capability: capability,
    resolution: resolution,
  };
}


function getSelectedMailboxForLegacyMetadata(resolution)
{
  if (resolution.selectedMailbox !== null && resolution.selectedMailbox !== undefined) {
    return resolution.selectedMailbox;
  }
  if (resolution.detectedMailbox !== null && resolution.detectedMailbox !== undefined) {
    return resolution.detectedMailbox;
  }
  return null;
}


/**
 * Load the clusters from config
 */
function populateSelectCluster() {
  const clusters = Clusterconfig.getUrls(AppState.debugMode);
  $('#select-cluster-url').html('');
  clusters.forEach(function(cluster) {
    $('#select-cluster-url').append($('<option>', {value: cluster.href, text: cluster.label}));
  });
}

function populateOffice(offices) {
  $('#div-office').show();
  $('#select-office').html('');
  offices.forEach(function(office) {
    $('#select-office').append($('<option>', {value: office.id, text: office.name}));
  })
}


/**
 *
 */
function uiUpdate()
{
  // Hide all sections and messages
  $('section').hide();
  $('#div-error').hide();
  $('#div-warning').hide();
  $('#div-success').hide();
  $('#div-loader').hide();

  if (AppState.debugMode) {
    $('.debug').show();
  } else {
    $('.debug').hide();
  }

  // Check if we need to select the cluster
  if (!Clusterconfig.isSet()) {
    logMessage('User needs to select cluster');
    populateSelectCluster();
    $('#section-select-cluster').show();
    return;
  }

  // Check if we need to login
  if (!Tokenstorage.hasTokens()) {
    logMessage('User needs to authenticate');
    $('#section-login').show();
    if (AppState.authenticationWarning !== null) {
      uiShowWarning(AppState.authenticationWarning, false);
    }
    return;
  }

  if (!NotarisdossierApi.accessTokenHasRequestedScopes()) {
    requireReauthentication('Meld eenmalig opnieuw aan om e-mails te kunnen opslaan');
    return;
  }

  AppState.authenticationWarning = null;

  // We're ready to save some messages :-)
  if (!AppState.configLoaded) {
    loadConfig();
  };
  uiRefreshMessage();
  uiUpdateSaveMailButton();
  $('#section-save-message').show();
}


/**
 * The save mail button is only enabled when there is a file selected and at least one checkbox is checked
 */
function uiUpdateSaveMailButton() {
  if (AppState.messageRefreshInProgress) {
    $('#btn-save-email').attr('disabled', 'disabled');
    return;
  }

  let fileIsSelected = $('#select-file').val() !== null;
  let saveEmlIsChecked = $('#cb-save-eml-message').prop('checked');
  let saveAttachmentIsChecked = $('.cb-attachment:checked').length > 0;
  if (fileIsSelected && (saveEmlIsChecked || saveAttachmentIsChecked)) {
    $('#btn-save-email').removeAttr('disabled');
  } else {
    $('#btn-save-email').attr('disabled', 'disabled');
  };
}


/**
 * @param msg
 */
function uiShowError(msg)
{
  uiHideLoader();
  logMessage('Show error message: ' + msg);
  $('#span-error-message').text(msg);
  $('#div-error').show();
  setTimeout(function () {
    $('#div-error').hide();
  }, 6000);
}


/**
 * @param msg
 * @param timer
 */
function uiShowWarning(msg, timer = true)
{
  uiHideLoader();
  logMessage('Show warning message: ' + msg);
  $('#span-warning-message').text(msg);
  $('#div-warning').show();
  if (timer) {
    setTimeout(function () {
      $('#div-warning').hide();
    }, 6000);
  }
}


/**
 * @param msg
 */
function uiShowSuccess(msg)
{
  uiHideLoader();
  logMessage('Show success message: ' + msg);
  $('#span-success-message').text(msg);
  $('#div-success').show();
  setTimeout(function () {
    $('#div-success').hide();
  }, 4000);
}


/**
 * @param msg
 */
function uiShowLoader(msg)
{
  logMessage('Show loader with message: ' + msg);
  $('#span-loader-message').text(msg);
  $('#div-loader').show();
}

/**
 * Hide the loader
 */
function uiHideLoader()
{
  $('#div-loader').hide();
}



/**
 * When a new message is selected we need to update the details of the message and attachments
 */
async function uiRefreshMessage(uploadSizeTooBig = false)
{
  const refreshVersion = ++AppState.messageRefreshVersion;
  AppState.messageRefreshInProgress = true;
  $('#btn-save-email').attr('disabled', 'disabled');

  const mailItem = Office.context.mailbox.item;

  // Update the select2 box
  updateFileSelectWithSubject(mailItem.subject);

  // We can only show the e-mail name when the config is loaded - don't worry, the layout is updated after the
  // config is loaded so it will only be hidden for a couple of ms.
  $('#cb-save-eml-message').prop('checked', true);
  $('#cb-save-eml-message').data('with-attachments', true);
  $('#switch-check-attachments').prop('checked', false);

  try {
    if (AppState.configLoaded) {
      let fileName = MailParser.getEmlFilename(AppState.messageFilenameFormat, mailItem);
      $('#email-file-name')[0].oldValue = '';
      $('#email-file-name').val(fileName.replace(/.eml/, ''));

      $('input[name="email-file-name"]').inputFilter(function(value) {
        // Note: although the / character is generally advised against to be allowed in a file name, this was specifically requested
        return /^(?! )[a-zA-Z0-9\]\[\/().,;:_ \-!@#$%&'+=~{}]*$/.test(value); }, "Gebruik alleen tekens die zijn toegestaan");
    }

    // Load all supported non-inline attachments as checkbox. Those are not checked by default. Attached e-mails and
    // cloud attachments keep the warning because the existing add-in cannot reliably download them.
    let numberOfAttachments = 0;
    let byteSizeOfAttachments = 0;
    $('#div-attachments').html('');
    mailItem.attachments.forEach((att) => {
      const isEmlAttachment = att.contentType === 'message/rfc822';
      const isCloudAttachment = String(att.attachmentType).toLowerCase() === 'cloud';
      if (!isEmlAttachment) {
        byteSizeOfAttachments += att.size;
      }
      if (att.isInline) {
        return;
      }

      let attName = att.name;
      if (attName.length > 50) {
        attName = attName.substring(0, 23) + ' ...' + attName.substring(attName.length - 10);
      }
      attName = escapeHtmlAttribute(attName);

      if (isEmlAttachment || isCloudAttachment) {
        $('#div-attachments').append(
          '<div class="form-check">' +
          '    <i class="bi bi-exclamation-triangle-fill text-danger"></i>' +
          '    <span class="form-check-label text-break">' + attName +
          '    </span>' +
          '</div>'
        );
        return;
      }

      const id = 'cb-save-att-' + ++numberOfAttachments;
      const icon = MailParser.getAttachmentIcon(att.contentType);
      $('#div-attachments').append(
        '<div class="form-check">' +
        '    <input class="form-check-input cb-attachment" type="checkbox" data-id="' +
        escapeHtmlAttribute(att.id) + '" id="' + id + '">' +
        '    <label class="form-check-label text-break" for="' + id + '">' +
        '        <i class="bi ' + icon.class + '" style="color: ' + icon.color + ';"></i> ' + attName +
        '    </label>' +
        '</div>'
      );
    });
    $('.cb-attachment').on('change', uiUpdateSaveMailButton);

    let mailWillSaveViaGraph = false;
    let capabilityUnavailableWarning = false;
    if (AppState.configLoaded) {
      try {
        const currentMailboxCapability = await resolveCurrentMailboxCapability(mailItem);
        mailWillSaveViaGraph = currentMailboxCapability.resolution.hasGraph;
      } catch (e) {
        capabilityUnavailableWarning = true;
        logMessage('Could not check Outlook message capability for UI: ' + (e.message !== undefined ? e.message : e));
      }
    }

    if (refreshVersion !== AppState.messageRefreshVersion) {
      return;
    }

    if (capabilityUnavailableWarning) {
      $('#header-eml-file').text('E-mail (inclusief bijlagen)');

      let warningTemplate =
        '<div class="alert alert-warning" role="alert" style="margin-bottom: 5px;">' +
        '   <i class="bi bi-exclamation-triangle-fill"></i>' +
        '<span> Outlook Graph configuratie kon niet worden gecontroleerd. Meld opnieuw aan of probeer opnieuw.</span>' +
        '</div>';
      $('#warning-eml-file').html(warningTemplate);

      $('#cb-save-eml-message').data('with-attachments', true);
    } else if (!mailWillSaveViaGraph && (byteSizeOfAttachments > AppState.maxUploadSize || uploadSizeTooBig)) {
      $('#header-eml-file').text('E-mail (exclusief bijlagen)');

      let warningTemplate =
        '<div class="alert alert-warning" role="alert" style="margin-bottom: 5px;">' +
        '   <i class="bi bi-exclamation-triangle-fill"></i>' +
          '<span> De e-mail is te groot om met bijlage(n) op te slaan. Selecteer de bijlage(n) om deze los op te slaan.</span>' +
        '</div>';
      $('#warning-eml-file').html(warningTemplate);

      $('#cb-save-eml-message').data('with-attachments', false);
      $('.cb-attachment').prop('checked', true);
      $('#switch-check-attachments').prop('checked', true);
    } else {
      $('#warning-eml-file').html('');
      $('#header-eml-file').text('E-mail (inclusief bijlagen)');
      $('#cb-save-eml-message').data('with-attachments', true);
    }


    // Do not show the checkboxes to select if we want to save the e-mail or attachments if there are no attachments
    if (numberOfAttachments === 0) {
      $('#div-attachements-container').hide();
      $('#td-save-eml-message').hide();
      $('#div-switch-check-attachments').hide();
    } else if (numberOfAttachments === 1) {
      $('#div-attachements-container').show();
      $('#td-save-eml-message').show();
      $('#div-switch-check-attachments').hide();
    } else {
      $('#div-attachements-container').show();
      $('#td-save-eml-message').show();
      $('#div-switch-check-attachments').show();
    }
  } finally {
    if (refreshVersion !== AppState.messageRefreshVersion) {
      return;
    }
    AppState.messageRefreshInProgress = false;
    uiUpdateSaveMailButton();
  }
}


/**
 * Click handler for the select cluster
 */
function btnSelectClusterClick()
{
  logMessage('btnSelectClusterClick()');
  let clusterUrl = $('#select-cluster-url').val();
  if (clusterUrl === '') {
    logMessage('Cluster is empty');
    uiShowError('Selecteer een cluster voordat je verder gaat');
  } else {
    Clusterconfig.setUrl(clusterUrl);
    uiUpdate();
  }
}


/**
 * Clear the authenticated state while preserving the selected cluster.
 */
function resetAuthenticatedState()
{
  Tokenstorage.clearTokens();
  AppState.configLoaded = false;
  AppState.messageFilenameFormat = null;
  AppState.outlookMessageCapability = null;
  AppState.graphMailboxes = [];
  AppState.messageRefreshVersion++;
  AppState.messageRefreshInProgress = false;
}


/**
 * @param message
 */
function requireReauthentication(message)
{
  logMessage('Access token is missing required scopes; reauthentication required');
  closePlatformSsoDialog();
  resetAuthenticatedState();
  AppState.authenticationWarning = message;
  uiUpdate();
}


/**
 * Click handler for the logout button
 */
function btnLogoutClick()
{
  logMessage('btnLogoutClock()');
  closePlatformSsoDialog();
  Clusterconfig.clear();
  resetAuthenticatedState();
  AppState.authenticationWarning = null;
  uiUpdate();
}


/**
 * Click handler for Platform SSO login.
 *
 * @param e
 */
function btnPlatformSsoClick(e)
{
  e.preventDefault();
  logMessage('btnPlatformSsoClick()');

  const nestedAuth = nestedAuthSettings();
  if (nestedAuth === null) {
    openPlatformSsoDialog();
    return;
  }

  signInWithNestedAuth(nestedAuth).catch((error) => {
    // The dialog links older accounts to the Platform and lets the user choose an office.
    logMessage('Nested app authentication failed: ' + (error && error.message ? error.message : error));
    openPlatformSsoDialog();
  });
}


/**
 * Outlook versions with nested app authentication give the add-in a token for
 * the signed-in account, so the Platform needs no sign-in dialog.
 *
 * @returns {{clientId: string, scope: string}|null}
 */
function nestedAuthSettings()
{
  try {
    if (!Office.context.requirements || !Office.context.requirements.isSetSupported('NestedAppAuth', '1.1')) {
      return null;
    }

    return Clusterconfig.getNestedAuth();
  } catch (e) {
    return null;
  }
}


/**
 * @param {{clientId: string, scope: string}} settings
 * @returns {Promise<void>}
 */
async function signInWithNestedAuth(settings)
{
  uiShowLoader('Bezig met aanmelden via SSO');
  const {acquirePlatformToken} = await import(/* webpackChunkName: "nested-auth" */ './library/nestedAuth');
  const accessToken = await acquirePlatformToken(settings);
  const platformUrl = Clusterconfig.getPlatformUrl();
  const offices = (await PlatformApi.getOffices(platformUrl, accessToken)).filter(function (office) {
    return office.isActive;
  });

  if (offices.length !== 1) {
    throw new Error('Nested app authentication needs exactly one active office');
  }

  const state = createPlatformSsoState();
  const handoff = await PlatformApi.createHandoff(platformUrl, accessToken, offices[0].officeUuid, buildPlatformSsoCallbackUrl(), state);
  if (handoff.state !== state) {
    throw new Error('Platform handoff state mismatch');
  }

  completePlatformHandoff(handoff);
}


function openPlatformSsoDialog()
{
  if (!Office.context.ui || !Office.context.ui.displayDialogAsync) {
    uiShowError('Aanmelden met SSO wordt niet ondersteund in deze Outlook versie');
    return;
  }

  AppState.platformSsoState = createPlatformSsoState();
  const startUrl = buildPlatformSsoStartUrl(AppState.platformSsoState);
  uiShowLoader('Bezig met aanmelden via SSO');

  Office.context.ui.displayDialogAsync(
    startUrl,
    {height: 60, width: 40, displayInIframe: false},
    function (result) {
      uiHideLoader();

      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        AppState.platformSsoState = null;
        logMessage('Platform SSO dialog failed: ' + result.error.code);
        uiShowError('Aanmelden met SSO kon niet worden geopend');
        return;
      }

      AppState.platformSsoDialog = result.value;
      AppState.platformSsoDialog.addEventHandler(
        Office.EventType.DialogMessageReceived,
        handlePlatformSsoDialogMessage
      );
      AppState.platformSsoDialog.addEventHandler(
        Office.EventType.DialogEventReceived,
        handlePlatformSsoDialogEvent
      );
    }
  );
}


function buildPlatformSsoStartUrl(state)
{
  const origin = window.location.protocol + '//' + window.location.host;
  const params = new URLSearchParams();
  params.set('platformUrl', Clusterconfig.getPlatformUrl());
  params.set('callbackUrl', buildPlatformSsoCallbackUrl());
  params.set('state', state);

  return origin + '/platform-handoff-start.html?' + params.toString();
}


function buildPlatformSsoCallbackUrl()
{
  return window.location.protocol + '//' + window.location.host + '/platform-handoff-callback.html';
}


function createPlatformSsoState()
{
  if (window.crypto && window.crypto.getRandomValues) {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);

    return Array.prototype.map.call(bytes, function (byte) {
      return ('0' + byte.toString(16)).slice(-2);
    }).join('');
  }

  return String(Date.now()) + String(Math.random()).replace(/[^0-9]/g, '');
}


function closePlatformSsoDialog()
{
  if (AppState.platformSsoDialog === null) {
    return;
  }

  try {
    AppState.platformSsoDialog.close();
  } catch (e) {
    logMessage('Could not close Platform SSO dialog');
  }

  AppState.platformSsoDialog = null;
}


function handlePlatformSsoDialogEvent(event)
{
  logMessage('Platform SSO dialog event: ' + event.error);
  AppState.platformSsoDialog = null;
  AppState.platformSsoState = null;
  uiHideLoader();

  if (event.error !== 12006) {
    uiShowError('Aanmelden met SSO is afgebroken');
  }
}


function handlePlatformSsoDialogMessage(arg)
{
  let message = {};

  try {
    message = JSON.parse(arg.message);
  } catch (e) {
    uiShowError('Aanmelden met SSO gaf een ongeldig antwoord');
    closePlatformSsoDialog();
    AppState.platformSsoState = null;
    return;
  }

  if (message.type !== 'platform-handoff') {
    return;
  }

  closePlatformSsoDialog();

  if (message.state !== AppState.platformSsoState) {
    AppState.platformSsoState = null;
    uiShowError('Aanmelden met SSO kon niet worden gecontroleerd');
    return;
  }

  AppState.platformSsoState = null;

  if (message.error) {
    uiShowError('Aanmelden met SSO is niet gelukt');
    return;
  }

  completePlatformHandoff(message);
}


/**
 * Exchanges an office handoff from the dialog or from nested app authentication.
 *
 * @param {{code: string, extOfficeUuid: string, clusterUrl: string}} message
 */
function completePlatformHandoff(message)
{
  if (!message.code || !message.extOfficeUuid || !message.clusterUrl) {
    uiShowError('Aanmelden met SSO gaf een onvolledig antwoord');
    return;
  }

  const clusterUrl = Clusterconfig.normalizeUrl(message.clusterUrl);
  if (!Clusterconfig.isKnownUrl(clusterUrl)) {
    uiShowError('Aanmelden met SSO gaf een onbekend cluster terug');
    return;
  }

  Clusterconfig.setUrl(clusterUrl);
  uiShowLoader('Bezig met aanmelden via SSO');

  NotarisdossierApi.exchangePlatformHandoff(message.code, message.extOfficeUuid).then(() => {
    try {
      MailParser.mailboxCreateCategoryIfNotExists();
    } catch (e) {
      logMessage('Error: ' + e.message);
    }

    uiUpdate();
    uiShowSuccess('Ingelogd met SSO');
  }).catch((error) => {
    generalExceptionHandler(error);
  });
}


/**
 * Submit handler for the login form
 *
 * @param e
 * @returns {Promise<void>}
 */
async function formLoginSubmit(e)
{
  e.preventDefault();
  logMessage('formLoginSubmit');

  $('#form-login').validate({
    errorClass: 'text-danger',
    errorElement: 'small',
    errorPlacement: function(error, element) {
      error.appendTo(element.parent().parent())
    },
    rules: {
      username: {required: true, email: true},
      password: {required: true, minlength: 8, maxlength: 100},
    },
    messages: {
      username: {required: 'Gebruikersnaam is vereist', email: 'Voer een geldig e-mailadres in'},
      password: {required: 'Wachtwoord is vereist', minlength: 'Vul hier minimaal 8 tekens in', maxlength: 'Vul hier maximaal 100 tekens in'},
    },
  });

  if ($('#form-login').valid()) {
    logMessage('Login form is valid');
    uiShowLoader('Bezig met aanmelden');
    const username = $('input[name=username]').val();
    const password = $('input[name=password]').val();
    let office = null;
    if ($('#select-office').val() !== undefined) {
      office = $('#select-office').val();
    }

    NotarisdossierApi.authenticate(username, password, office).then(() => {
      try {
        MailParser.mailboxCreateCategoryIfNotExists(); // also check if the category is already created upon login
      } catch (e) {
        logMessage('Error: ' + e.message);
      }

      uiUpdate();
      uiShowSuccess('Ingelogd als ' + username);
    }).catch((error) => {
        if (error.hasOwnProperty('offices')) {
          populateOffice(error.offices);
          uiShowError('Selecteer een kantoor');
        } else if (error.hasOwnProperty('message')) {
          uiShowError(error.message);
        } else {
          uiShowError(error);
        }
    });
  }
}


/**
 * Load config. We perform 2 API calls - it is possible in one, but this is more convenient.
 */
function loadConfig()
{
  logMessage('loadConfig');
  NotarisdossierApi.getSettings(NotarisdossierApi.folderNameSettings).then((folders) => {
      let html = '';
      Object.values(folders).forEach((element) => html += '<option value="' + element + '">' + element + '</option>');
      $("#select-folder").html(html);
      NotarisdossierApi.getSettings(['save-message-filename-format']).then((format) => {
        AppState.messageFilenameFormat = Object.values(format)[0];
        NotarisdossierApi.getOutlookMessageCapability().then((capability) => {
          AppState.outlookMessageCapability = capability;
          AppState.graphMailboxes = capability !== null && capability !== undefined && capability.mailboxes !== undefined ? capability.mailboxes : [];
          logMessage('Outlook message capability loaded, graph mailboxes: ' + AppState.graphMailboxes.length);
          AppState.configLoaded = true;
          uiUpdate();
        }).catch((error) => {
          if (error !== null && error !== undefined && error.status === 403) {
            uiShowError('Meld opnieuw aan om Outlook Graph rechten te activeren');
          } else {
            generalExceptionHandler(error);
          }
        });
      }).catch(() => {
        uiShowError('Fout bij ophalen config');
      });
  }).catch((error) => {
      error = {
        status: error.status,
        message: 'Fout bij ophalen mappen'
      };
      generalExceptionHandler(error);
    });
}


async function updateFileSelectWithSubject(subject) {
  logMessage('updateFileSelectWithSubject');
  NotarisdossierApi.searchFile(subject, true).then((json) => {
    if (json.length > 0) {
      var newOption = new Option(json[0].reference + " - " + json[0].name, json[0].file_uuid, true, true);
      $("#select-file").append(newOption).trigger('change');
    } else {
      logMessage('-> No matching file found');
    }
  }).catch((error) => {
    if (error.message !== undefined) {
      logMessage('Error: ' + error.message);
    } else {
      logMessage('Error: ' + error);
    }
  });
}

/**
 * Init the Select2 for the file. It needs to call the API when searching, so basically the entire transport function
 * is overridden.
 *
 * @returns {Promise<void>}
 */
async function initSelectFile()
{
  $('#select-file').select2({
    width: "100%",
    placeholder: "Zoek hier naar een dossier",
    minimumInputLength: 4,
    ajax: {
      quietMillis: 750,
      dataType: 'json',
      transport: async function (params, success, failure) {
        NotarisdossierApi.searchFile(params.data.term)
          .then((json) => {
            success(json);
          }).catch((error) => {
            generalExceptionHandler(error);
            failure();
          });
      },
      processResults: function (data) {
        let results = $.map(data, function (obj) {
           return {id: obj.file_uuid, text: obj.reference + ' - ' + obj.name};
        });
        return {
          results: results,
        };
      },
    },
  });
  $('#select-file').on('change', function() {
    uiUpdateSaveMailButton();
  });
}


function escapeHtmlAttribute(value)
{
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}


function getSelectedAttachmentIds()
{
  let attachmentIds = [];
  $('.cb-attachment:checked').each(function() {
    const attachmentId = $(this).attr('data-id');
    if (attachmentId !== undefined && attachmentId !== null && String(attachmentId).length > 0) {
      attachmentIds.push(String(attachmentId));
    }
  });
  return attachmentIds;
}


function capabilitySupportsGraphAttachmentSelection(capability)
{
  return getBooleanCapability(capability, ['graph_attachment_selection_available']) === true &&
    capability.graph_attachment_id_type === 'graph-rest-id';
}


function convertAttachmentIdsToGraphRestIds(attachmentIds)
{
  return attachmentIds.map((attachmentId) => Office.context.mailbox.convertToRestId(
    attachmentId,
    Office.MailboxEnums.RestVersion.v2_0
  ));
}


function mailItemHasEmlAttachments(mailItem)
{
  try {
    for (let i = 0; i < mailItem.attachments.length; i++) {
      if (mailItem.attachments[i].contentType === 'message/rfc822') {
        return true;
      }
    }
  } catch (e) {
    logMessage('Could not read attachments of mail item: ' + e.message);
  }
  return false;
}


async function getMailItemAttachmentsContent(mailItem)
{
  let attachments = [];
  if (MailParser.isLegacyOutlook()) {
    await Tokenstorage.refreshAttachmentTokenIfNeeded();
    attachments = await MailParser.legacyMailItemGetAttachmentsContent(mailItem);
  } else {
    attachments = await MailParser.mailItemGetAttachmentsContent(mailItem);
  }
  logMessage('Attachment content loaded');
  return attachments;
}


function attachmentsIncludeMessageRfc822(attachments)
{
  for (let i = 0; i < attachments.length; i++) {
    if (attachments[i].contentType === 'message/rfc822') {
      return true;
    }
  }
  return false;
}


function markMailItemSaved(mailItem)
{
  try {
    MailParser.mailItemAddCategory(mailItem);
  } catch (e) {
    logMessage('Error: ' + e.message);
  }
}


function getGraphSaveUserError(error)
{
  const status = error !== null && error !== undefined && error.status !== undefined ? error.status : null;
  const message = error !== null && error !== undefined && error.message !== undefined ? error.message : error;
  return {
    status: status,
    message: 'Fout bij opslaan e-mail via Outlook Graph' + (status !== null ? ' (' + status + ')' : '') +
      (message !== undefined && message !== null ? ': ' + message : ''),
  };
}


function logGraphNoLegacyFallback(error)
{
  const status = error !== null && error !== undefined && error.status !== undefined ? error.status : 'unknown';
  const message = error !== null && error !== undefined && error.message !== undefined ? error.message : error;
  logMessage('Graph save failed, status=' + status + ', message=' + message + '; no legacy fallback');
}


function shouldRetryGraphSaveWithRestId(error)
{
  if (error === null || error === undefined) {
    return false;
  }

  if (error.status === 404) {
    return true;
  }

  return error.response !== null &&
    error.response !== undefined &&
    error.response.error_code === 'graph_message_id_translation_failed' &&
    error.response.retry_with_rest_id === true;
}


/**
 * Save via Graph, retrying with a REST id when Graph cannot translate the Outlook EWS id.
 *
 * @param mailItem
 * @param params request params without message_id/message_id_type
 * @returns {Promise<object>} the API response
 */
async function postGraphSave(mailItem, params)
{
  try {
    return await NotarisdossierApi.saveOutlookMessage(
      Object.assign({}, params, {
        message_id: mailItem.itemId,
        message_id_type: 'ews-id',
      })
    );
  } catch (error) {
    if (!shouldRetryGraphSaveWithRestId(error)) {
      logGraphNoLegacyFallback(error);
      throw getGraphSaveUserError(error);
    }

    logMessage('Graph save could not use ews-id, retry with graph-rest-id');
    try {
      const restId = Office.context.mailbox.convertToRestId(
        mailItem.itemId,
        Office.MailboxEnums.RestVersion.v2_0
      );
      return await NotarisdossierApi.saveOutlookMessage(
        Object.assign({}, params, {
          message_id: restId,
          message_id_type: 'graph-rest-id',
        })
      );
    } catch (retryError) {
      logGraphNoLegacyFallback(retryError);
      throw getGraphSaveUserError(retryError);
    }
  }
}


/**
 * Save the e-mail and, when requested, the selected attachments via Graph.
 */
async function saveMessageViaGraph(mailItem, fileUuid, folderName, fileName, selectedMailbox, graphAttachmentIds)
{
  const saveAttachments = graphAttachmentIds.length > 0;
  logMessage(
    'Save route: graph, mailbox=' + selectedMailbox + ', selected_attachments=' + graphAttachmentIds.length
  );
  uiShowLoader('Bezig met opslaan e-mail');

  const params = {
    file_uuid: fileUuid,
    folder: folderName,
    name: fileName,
    mailbox: selectedMailbox,
    mark_saved: true,
    save_attachments: saveAttachments,
  };
  if (saveAttachments) {
    params.attachment_ids = graphAttachmentIds;
    params.attachment_id_type = 'graph-rest-id';
  }

  const response = await postGraphSave(mailItem, params);

  markMailItemSaved(mailItem);
  return response;
}


/**
 * Save only the selected attachments via Graph, straight into the selected folder.
 */
async function saveSelectedAttachmentsViaGraph(mailItem, fileUuid, folderName, selectedMailbox, graphAttachmentIds)
{
  const emlAttachments = mailItemHasEmlAttachments(mailItem);
  if (graphAttachmentIds.length === 0) {
    return {saved: false, errors: 0, attachmentsIncludeMessageRfc822: emlAttachments};
  }

  logMessage('Save route: graph attachments, count=' + graphAttachmentIds.length);
  if (graphAttachmentIds.length > 1) {
    uiShowLoader('Bezig met opslaan bijlagen');
  } else {
    uiShowLoader('Bezig met opslaan bijlage');
  }

  const response = await postGraphSave(mailItem, {
    file_uuid: fileUuid,
    folder: folderName,
    mailbox: selectedMailbox,
    mark_saved: false,
    save_message: false,
    save_attachments: true,
    attachment_ids: graphAttachmentIds,
    attachment_id_type: 'graph-rest-id',
  });

  logGraphSaveWarnings(response);

  const attachmentsSaved = getAttachmentsSavedCount(response);
  if (attachmentsSaved !== graphAttachmentIds.length) {
    logMessage(
      'Graph saved ' + attachmentsSaved + ' of ' + graphAttachmentIds.length + ' selected attachments'
    );
    uiShowError(
      graphAttachmentIds.length > 1
        ? 'Niet alle bijlagen konden worden opgeslagen'
        : 'Fout bij opslaan bijlage'
    );
    return {
      saved: false,
      errors: Math.max(graphAttachmentIds.length - attachmentsSaved, 1),
      attachmentsIncludeMessageRfc822: emlAttachments,
    };
  }

  return {saved: true, errors: 0, attachmentsIncludeMessageRfc822: emlAttachments};
}


function getAttachmentsSavedCount(response)
{
  if (response !== null && response !== undefined && typeof response.attachments_saved === 'number') {
    return response.attachments_saved;
  }
  return 0;
}


function logGraphSaveWarnings(response)
{
  if (response === null || response === undefined || !Array.isArray(response.warnings)) {
    return;
  }
  response.warnings.forEach((warning) => {
    logMessage('Graph save warning: ' + warning);
  });
}


async function saveMessageViaLegacy(mailItem, fileUuid, folderName, fileName, selectedMailbox, legacyReason)
{
  logMessage('Save route: legacy, reason=' + legacyReason + ', mailbox=' + selectedMailbox);
  uiShowLoader('Bezig met opslaan e-mail');

  const attachments = await getMailItemAttachmentsContent(mailItem);
  const emlWithAttachments = $('#cb-save-eml-message').data('with-attachments');
  let eml = await MailParser.createEml(mailItem, attachments, emlWithAttachments);
  if (eml.length > AppState.maxUploadSize) {
    logMessage('Legacy save blocked: EML exceeds max upload size');
    throw {
      message: 'Mail is te groot, sla bestanden los op. Er is niets is opgeslagen',
      legacyUploadSize: true,
    };
  }

  await NotarisdossierApi.addFileInternalDocument(fileUuid, fileName, folderName, eml, false, {
    source: 'outlook-addin',
    save_method: 'legacy-js-eml',
    legacy_reason: legacyReason,
    mailbox: selectedMailbox,
  });
  markMailItemSaved(mailItem);
  return attachments;
}


async function saveSelectedAttachmentsViaLegacy(mailItem, fileUuid, folderName, knownAttachments = null)
{
  const selectedAttachmentIds = getSelectedAttachmentIds();
  if (selectedAttachmentIds.length === 0) {
    return {
      saved: false,
      errors: 0,
      attachmentsIncludeMessageRfc822: false,
      attachments: knownAttachments || [],
    };
  }

  logMessage('Save route: legacy attachments, count=' + selectedAttachmentIds.length);
  if (selectedAttachmentIds.length > 1) {
    uiShowLoader('Bezig met opslaan bijlagen');
  } else {
    uiShowLoader('Bezig met opslaan bijlage');
  }

  const attachments = knownAttachments !== null ? knownAttachments : await getMailItemAttachmentsContent(mailItem);
  let errors = 0;

  for (let i = 0; i < selectedAttachmentIds.length; i++) {
    const attachmentId = selectedAttachmentIds[i];
    const index = attachments.findIndex((attachment) => attachment.id === attachmentId);
    if (index === -1) {
      errors++;
      uiShowError('Fout bij opslaan bijlage');
      continue;
    }

    const attachment = attachments[index];
    try {
      await NotarisdossierApi.addFileInternalDocument(fileUuid, attachment.name, folderName, attachment.content, true);
    } catch (e) {
      errors++;
      uiShowError('Fout bij opslaan bijlage "' + attachment.name + '"');
    }
  }

  return {
    saved: errors === 0,
    errors: errors,
    attachmentsIncludeMessageRfc822: attachmentsIncludeMessageRfc822(attachments),
    attachments: attachments,
  };
}


function showSaveSuccess(savedEmail, savedAttachments, attachmentErrors)
{
  if (attachmentErrors > 0) {
    return;
  }

  if (savedEmail && savedAttachments) {
    uiShowSuccess('E-mail en bijlagen opgeslagen');
  } else if (savedEmail) {
    uiShowSuccess('E-mail opgeslagen');
  } else if (savedAttachments) {
    if (getSelectedAttachmentIds().length > 1) {
      uiShowSuccess('Bijlagen opgeslagen');
    } else {
      uiShowSuccess('Bijlage opgeslagen');
    }
  }
}


/**
 * Handler for the save mail button.
 *
 * @returns {Promise<void>}
 */
async function btnSaveMailClick()
{
  logMessage('btnSaveMailClick()');
  $('#btn-save-email').attr('disabled', 'disabled');

  const mailItem = Office.context.mailbox.item;
  const fileUuid = $('#select-file').val();
  let folderName = $('#select-folder').val();

  if (folderName.length < 1) {
    uiShowError('Selecteer een map om de e-mail op te slaan');
    uiUpdateSaveMailButton();
    return;
  }

  let fileName = $('#email-file-name').val();
  if (fileName.length <= 4 || fileName.toLowerCase() == 'bestandsnaam') {
    fileName = MailParser.getEmlFilename(AppState.messageFilenameFormat, mailItem);
  } else {
    fileName = fileName + '.eml';
  }

  const saveEmlMessage = $('#cb-save-eml-message').prop('checked');
  const selectedAttachmentIds = getSelectedAttachmentIds();
  let savedEmail = false;
  let savedAttachments = false;
  let attachmentErrors = 0;
  let attachmentsContainMessageRfc822 = false;

  try {
    if (saveEmlMessage) {
      const currentMailboxCapability = await resolveCurrentMailboxCapability(mailItem);
      const capability = currentMailboxCapability.capability;
      const mailboxResolution = currentMailboxCapability.resolution;

      if (mailboxResolution.hasGraph && mailboxResolution.selectedMailbox !== null) {
        const graphAttachmentSelection = capabilitySupportsGraphAttachmentSelection(capability);
        const graphAttachmentIds = graphAttachmentSelection
          ? convertAttachmentIdsToGraphRestIds(selectedAttachmentIds)
          : [];
        const response = await saveMessageViaGraph(
          mailItem,
          fileUuid,
          folderName,
          fileName,
          mailboxResolution.selectedMailbox,
          graphAttachmentIds
        );
        savedEmail = true;
        logGraphSaveWarnings(response);

        if (graphAttachmentSelection && selectedAttachmentIds.length > 0) {
          const attachmentsSaved = getAttachmentsSavedCount(response);
          savedAttachments = attachmentsSaved === selectedAttachmentIds.length;
          attachmentErrors = savedAttachments ? 0 : Math.max(selectedAttachmentIds.length - attachmentsSaved, 1);
          if (attachmentErrors > 0) {
            uiShowError('Niet alle bijlagen konden worden opgeslagen');
          }
        } else if (selectedAttachmentIds.length > 0) {
          logMessage('Graph attachment selection unavailable; use legacy attachment upload');
          const attachmentResult = await saveSelectedAttachmentsViaLegacy(mailItem, fileUuid, folderName);
          savedAttachments = attachmentResult.saved;
          attachmentErrors = attachmentResult.errors;
          attachmentsContainMessageRfc822 = attachmentResult.attachmentsIncludeMessageRfc822;
        }
        if (!attachmentsContainMessageRfc822) {
          attachmentsContainMessageRfc822 = mailItemHasEmlAttachments(mailItem);
        }
      } else if (capabilityAllowsLegacy(capability)) {
        const legacyReason = mailboxResolution.legacyReason || 'graph_unavailable';
        const selectedMailbox = getSelectedMailboxForLegacyMetadata(mailboxResolution);
        const attachments = await saveMessageViaLegacy(
          mailItem,
          fileUuid,
          folderName,
          fileName,
          selectedMailbox,
          legacyReason
        );
        savedEmail = true;
        if (selectedAttachmentIds.length > 0) {
          const attachmentResult = await saveSelectedAttachmentsViaLegacy(mailItem, fileUuid, folderName, attachments);
          savedAttachments = attachmentResult.saved;
          attachmentErrors = attachmentResult.errors;
          attachmentsContainMessageRfc822 = attachmentResult.attachmentsIncludeMessageRfc822;
        } else {
          attachmentsContainMessageRfc822 = attachmentsIncludeMessageRfc822(attachments);
        }
      } else {
        logMessage(
          'Save route: blocked, graph=false, legacy=false, mailbox=' +
          getSelectedMailboxForLegacyMetadata(mailboxResolution) +
          ', reason=' + mailboxResolution.legacyReason
        );
        throw {
          message: 'Deze mailbox is niet geautoriseerd voor Graph en legacy opslaan is niet toegestaan',
        };
      }
    } else if (selectedAttachmentIds.length > 0) {
      let attachmentResult;
      let currentMailboxCapability = null;
      try {
        currentMailboxCapability = await resolveCurrentMailboxCapability(mailItem);
      } catch (e) {
        logMessage('Graph attachment selection capability unavailable; use legacy attachment upload');
      }

      if (currentMailboxCapability !== null &&
        currentMailboxCapability.resolution.hasGraph &&
        currentMailboxCapability.resolution.selectedMailbox !== null &&
        capabilitySupportsGraphAttachmentSelection(currentMailboxCapability.capability)) {
        const graphAttachmentIds = convertAttachmentIdsToGraphRestIds(selectedAttachmentIds);
        attachmentResult = await saveSelectedAttachmentsViaGraph(
          mailItem,
          fileUuid,
          folderName,
          currentMailboxCapability.resolution.selectedMailbox,
          graphAttachmentIds
        );
      } else {
        logMessage('Graph attachment selection unavailable; use legacy attachment upload');
        attachmentResult = await saveSelectedAttachmentsViaLegacy(mailItem, fileUuid, folderName);
      }

      savedAttachments = attachmentResult.saved;
      attachmentErrors = attachmentResult.errors;
      attachmentsContainMessageRfc822 = attachmentResult.attachmentsIncludeMessageRfc822;
    }

    showSaveSuccess(savedEmail, savedAttachments, attachmentErrors);
    if (attachmentsContainMessageRfc822) {
      uiShowWarning('Bijlage(n) .eml worden niet opgeslagen! Download deze handmatig');
    }
  } catch (error) {
    if (error !== null && error !== undefined && error.legacyUploadSize) {
      uiRefreshMessage(true);
    }
    generalExceptionHandler(error);
  } finally {
    uiUpdateSaveMailButton();
  }
}

/**
 * Function for validating inputs
 * @par callback function for validation
 * @par errMsg automated message above input
 *
 * Validators op inputs, te gebruiken door:
 * `veld`.inputFilter(function(value) { return `regex`.test(value); }, `errormessage`)
 */
(function($) {
  $.fn.inputFilter = function(callback, errMsg) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop focusout", function(e) {
      if (callback(this.value)) {
        // Accepted value
        if (["keydown","mousedown","focusout"].indexOf(e.type) >= 0){
          this.setCustomValidity("");
        }
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        // Rejected value - restore the previous one
        this.setCustomValidity(errMsg);
        this.reportValidity();
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        // Rejected value - nothing to restore
        this.value = "";
      }
    });
  };
}(jQuery));
